import axios, { AxiosError } from 'axios';
import { ISignupWithQuestions } from 'src/interfaces';
import http from './http';

class SignupService {
  static signup(data: ISignupWithQuestions, token: string) {
    return http.post('/auth/signup', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  static signupExternalUser(data: { email: string; companies: string[] }) {
    return http
      .post('/auth/signup/external-user', data)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static signupExternalClientUser(data: any) {
    return http
      .post('/auth/signup/external-client-user', data)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message || 'Failed to create user');
        }
        throw err;
      });
  }

  static uploadExternalClientUsers(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return http
      .post('/auth/signup/external-client-users/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message || 'Failed to upload users');
        }
        throw err;
      });
  }

  static deleteExternalUser(email: string): Promise<void> {
    return http
      .delete(`/auth/signup/external-user/${email}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default SignupService;
